module.exports = __webpack_public_path__ + "static/img/zhaoshang-2.149a909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/zhaoshang-2.png
// module id = 177
// module chunks = 1